"use strict";

const EVENT_USERAUTHENTICATED = "oidc_user_authenticated";
const EVENT_USERCHANGED = "oidc_user_changed";

angular.module("Finance").controller("mainController", [
    "$rootScope",
    "$scope",
    "$state",
    "$http",
    "$timeout",
    "$sessionStorage",
    "$activity",
    "$notification",
    "$modal",
    "$language",
    "$user",
    "$oidc",
    function (
        $rootScope,
        $scope,
        $state,
        $http,
        $timeout,
        $sessionStorage,
        $activity,
        $notification,
        $modal,
        $language,
        user,
        oidc
    ) {

        if (location.href.includes('signagain=true')) {
            oidc.signOut();
        }

        // Page title
        $scope.pageTitle = "Finance";

        // Notifications
        $scope.$notification = $notification;

        $scope.invoice = {
            number: null
        };

        // Storage
        $scope.$storage = $sessionStorage.$default({
            user: {
                //Id: -1,
                FullName: "",
                IsAdmin: false,
                Retailer: {
                    Id: -1,
                    DisplayName: ""
                }
            },
            retailer: {
                Id: -1,
                DisplayName: ""
            },
            retailers: []
        });

        // Retailers
        $scope.loadRetailers = function () {
            $activity.start();
            return $http
                .get("/api/retailer",
                    {
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    })
                .then(
                    function (response) {
                        $scope.$storage.retailers = response.data;
                    },
                    function (response) {
                        $notification.addError(response);
                    }
                )
                .then(function () {
                    $activity.finish();
                });
        };

        // Print
        $scope.print = function () {
            window.print();
        };

        // About
        $scope.loadAbout = function () {
            $activity.start();
            $http.get("/api/about").then(
                function (response) {
                    $activity.finish();
                    $scope.about = response.data;
                },
                function (response) {
                    $activity.finish();
                    $notification.addError(response.statusText, response);
                }
            );
        };

        // User settings
        $scope.userSettings = function () {
            $modal.open({
                template: require("../../Templates/userSettings.html"),
                controller: "userSettingsController"
            });
        };

        // Invoice quick search
        $scope.invoiceSearch = function () {
            $state.go(
                "invoice-browse.search",
                { invoiceNo: $scope.invoice.number },
                { reload: true }
            );
            $scope.invoice.number = "";
        };

        $scope.loadRetailer = function () {
            var retId =
                $scope.$storage.retailer.Id == -1
                    ? user.retailerId
                    : $scope.$storage.retailer.Id;

            $http
                .get("api/retailer/" + retId, {
                    headers: {
                        Authorization: oidc.current.token_type + " " + oidc.current.access_token
                    }
                })
                .then(function (response) {
                    $scope.$storage.retailer = response.data;
                });

            if (
                $scope.user.isOnBehalfOfDealers &&
                (typeof $scope.$storage.retailers === "undefined" ||
                    $scope.$storage.retailers.length === 0)
            ) {
                $scope.loadRetailers();
            }
        };

        // On load
        $scope.loadAbout();

        $scope.user = user;

        $scope.logout = function () {
            $scope.$storage.retailer = {
                Id: -1,
                DisplayName: ""
            };
            window.location.href = $scope.getlogoutUrl("Finance");
        };

        $scope.getlogoutUrl = function (appName) {

            let baseUrl = __FINANCE__.auth.authority;
            let returnUrlParam = encodeURIComponent(location.origin + "?signagain=true");
            return baseUrl + "Sign-out?appName=" + appName + "&returnUrl=" + returnUrlParam;
        }

        $rootScope.$on(EVENT_USERAUTHENTICATED, function () {
            console.log(EVENT_USERAUTHENTICATED);

            $scope.loadRetailer();
        });

        $rootScope.$on(EVENT_USERCHANGED, function () {
            console.log(EVENT_USERCHANGED);

            $scope.loadRetailer();
        });
    }
]);